import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ErrorLogService {

  constructor() { }

  logError(error: any): void {
    // Aqui você pode adicionar sua lógica personalizada de registro de erros
    console.error('Erro:', error);
    // Faça chamadas a serviços de log, envie para um servidor, etc.
  }
}
